export default __webpack_public_path__ + "static/media/slider3-3.7ae784ec.jpg";